export enum NAVIGATION_COMPONENT_TYPE {
  K_TREE = 'K_TREE',
  SUBJECT = 'SUBJECT',
  EVENT = 'EVENT',
  CUBE = 'CUBE',
  INSIGHT_VIEW = 'INSIGHT_VIEW',
  STANDARD_VIEW = 'STANDARD_VIEW',
  DASHBOARD = 'DASHBOARD',
  SUBJECT_PROCEDURE = 'SUBJECT_PROCEDURE',
  CHART = 'CHART',
  TABLE_ANALYTIC = 'TABLE_ANALYTIC',
}

export enum BREADCRUMB_ACTION_TYPE {
  EDIT = 'EDIT',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
}

export enum DASHBOARD_DISPLAY_TYPE {
  DASHBOARD_LIST = 'DASHBOARD_LIST',
  MY_VIEW_LIST = 'MY_VIEW_LIST',
}

export const FOOTER_MENU_LINK = {
  PRIVACY_POLICY: 'https://www.arotarget.com/privacy-policy',
  TERMS_OF_USE: 'https://www.arotarget.com/terms-of-service',
};

export const FOOTER_MENU_OPTIONS = [
  {
    label: 'Privacy Policy',
    link: FOOTER_MENU_LINK.PRIVACY_POLICY,
  },
  {
    label: 'Terms of Use',
    link: FOOTER_MENU_LINK.TERMS_OF_USE,
  },
];
